/**
 * Download config · UGC 社媒热门创意详情页
 *
 * Drawer 内 Related Videos 区域的下载入口（type: "page"，按页拉 /ugc_trends/related_videos 接口，
 * 一次下载完该 trend 下全部关联视频）。
 *
 * 字段对齐 specs/UGC社媒热门创意详情页/api/related_videos.md（VideoItem 结构）。
 */
import { channelRenderHelper } from '@op/pages/download/renderHelper';
import { DownloadConfigInfoType } from '@op/pages/download/types';
import { getUgcTrendRelatedVideos } from '@opm/services';

export const MarketingUgcRelatedVideosDownload: DownloadConfigInfoType = {
  type: 'page',
  downloadFunc: params => {
    return getUgcTrendRelatedVideos({ data: params });
  },
  columns: () => {
    return [
      { key: 'title', header: 'Video Title' },
      {
        key: 'channel_code',
        header: 'Channel',
        renderHelper: [channelRenderHelper],
      },
      { key: 'video_url', header: 'URL' },
      { key: 'comment_time', header: 'Release Time' },
      { key: 'duration', header: 'Duration(s)' },
      { key: 'tweets_view', header: 'Views' },
      { key: 'tweets_like', header: 'Likes' },
      { key: 'engagement', header: 'Engagement' },
      // { key: 'follower_number', header: 'Author Followers' },
    ];
  },
};
